import script from "./ProvinceSelectorModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProvinceSelectorModal.vue?vue&type=script&setup=true&lang=js"

import "./ProvinceSelectorModal.vue?vue&type=style&index=0&id=5559719b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5559719b"]])

export default __exports__